import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import { genericProjectLayout } from '@atlassian/jira-generic-project-layout';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async';
import { type Route, createEntry } from '@atlassian/jira-router';
import {
	getNavigationResources,
	getNavigationSidebarProjectResource,
} from '@atlassian/jira-router-resources-navigation';
import { archivedIssuesRedirectRoute } from '@atlassian/jira-router-routes-archives-routes';
import { ErrorPagesNotFound } from '@atlassian/jira-router-routes-common';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page';

export const LazyArchives = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-issues-archive", jiraSpaEntry: "async-issues-archive" */ '@atlassian/jira-spa-apps-archives'
		).then(({ JiraIssuesArchive }) => JiraIssuesArchive),
	),
);

export const Archives = () => (
	<LazyPage Page={LazyArchives} pageId="spa-apps/archives" shouldShowSpinner />
);

export const archivedIssuesRedirectRouteEntry: Route = createEntry(archivedIssuesRedirectRoute, {
	component: componentWithFF('issues-archive-route_a4t84', Archives, ErrorPagesNotFound),
	layout: genericProjectLayout,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarNextGen,
	},
	resources: [...getNavigationResources(), ...getNavigationSidebarProjectResource()],
	forPaint: [LazyAtlassianNavigation, LazyArchives],
});
